@if (programmePerformanceList) {

    <div class="
        grid
        grid-cols-1
        md:grid-cols-2
        lg:grid-cols-3
        gap-4
        ">
        @for (programmePerformance of programmePerformanceList; track programmePerformance.id) {
            @if(programmePerformance.performance; as performance) {
                <div class="block flex border rounded-lg p-4 border-slate-500">
                    <div>
                        <p class="text-2xl pr-3 font-semibold">{{ programmePerformance.sequenceNo }}</p>
                    </div>
                    <div class="grow">
                        @for (performanceItem of performance.performanceItemList; track performanceItem.id) {
                            <div class="flex">
                                <div class="grow">
                                    <h3 class="mb-1">{{ performanceItem.name }}</h3>
                                    @for (performancePerformer of performanceItem.performerList; track performancePerformer.id) {
                                        <div>
                                            <p class="text-lg">{{ performancePerformer.performer?.name }}</p>
                                        </div>
                                    }
                                    <p class="text-base">{{ performance.name }}</p>
                                </div>
                                @if(_userService.isLoggedIn$ | async) {
                                    <div>
                                        <app-outline-star-icon 
                                            class="block w-[44px] h-[44px] cursor text-gray-300 hover:text-gray-500 transition">
                                        </app-outline-star-icon>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </div>
            }
        }
    </div> 
}